import styled from 'styled-components';
import { Card } from 'antd';

export const VISA = 'visa';
export const MASTERCARD = 'mastercard';

export const StandardMethodPlaceholder = styled.div`
  height: 32px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const PaymentMethodWrapper = styled(Card)<{
  justifycontent?: 'space-around' | 'space-between';
}>`
  display: flex;
  align-items: center;
  padding-inline: 33px;
  height: 124px;
  text-align: center;

  .ant-card-body {
    min-width: 100%;
    justify-content: ${({ justifycontent }) => justifycontent || 'space-around'};
  }

  .ant-typography {
    text-align: center;
  }
`;
